import React from 'react';
import { Alert } from '@/components/ui';

interface YellowHeaderInfoProps {
  /** The column that carries the yellow header, so the note points at something on screen. */
  columnLabel: string;
}

/**
 * Note for a report whose preview has one reference-only column (yellow header). Only render it
 * when that column is actually in the preview - a note about headers nobody can see is noise.
 */
const YellowHeaderInfo: React.FC<YellowHeaderInfoProps> = ({ columnLabel }) => (
  <Alert variant="info" className="tw-flex tw-items-center tw-mb-3">
    <i className="bi bi-info-circle tw-mr-2" aria-hidden="true"></i>
    <span>
      <strong>Note:</strong> The {columnLabel} column (yellow header) is for reference only and is not included in the exported report.
    </span>
  </Alert>
);

export default YellowHeaderInfo;
